import { render, staticRenderFns } from "./ImportNewFrGroup.vue?vue&type=template&id=34f23662"
import script from "./ImportNewFrGroup.vue?vue&type=script&lang=js"
export * from "./ImportNewFrGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports